import { render, staticRenderFns } from "./AuditionList.vue?vue&type=template&id=57453562&"
import script from "./AuditionList.vue?vue&type=script&lang=js&"
export * from "./AuditionList.vue?vue&type=script&lang=js&"
import style0 from "./AuditionList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports